import { login, logout, getAccessToken } from "./AuthorizationService";

const AuthorizationService = { login, logout, getAccessToken }
export default AuthorizationService;
